import { SignIn, SignUp } from "@clerk/react";

const Side = () => (
  <div className="hidden lg:flex flex-col justify-between w-[44%] bg-slate-900 p-12 text-slate-300">
    <div className="flex items-center gap-2">
      <div className="h-8 w-8 rounded bg-sky-500 grid place-items-center text-slate-950 font-bold font-display">T</div>
      <span className="text-slate-100 font-semibold font-display">Tessol Platform</span>
    </div>
    <div>
      <h1 className="text-4xl font-semibold text-white leading-tight font-display">Orders, masters and design records in one governed shell.</h1>
      <p className="mt-4 text-sm text-slate-400 max-w-md">Module 1 · Order Hub, Customers & Parts masters, Design Hub v0.1.</p>
    </div>
    <div className="text-xs font-mono text-slate-500">Internal use only</div>
  </div>
);

export function SignInPage({ mode }) {
  return (
    <div className="min-h-screen flex bg-slate-50" data-testid={`${mode}-page`}>
      <Side />
      <div className="flex-1 flex items-center justify-center p-4">
        {mode === "sign-in"
          ? <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
          : <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />}
      </div>
    </div>
  );
}
